// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

import thirdPartyUtils from '../../../global/utils/thirdPartyUtils';

// import form components
import { EmailInput, PasswordInput } from '../../../global/components/forms';

function UserLoginForm({
  handleFormChange
  , handleFormSubmit
  , user
  , toggleSSOModal
}) {
  return (
    <form name="userForm" className="user-login-form" onSubmit={handleFormSubmit}>
      <img className="-partner-logo" src="/img/logo-pd0.png" />
      <h1 className="-form-header"> Welcome back!</h1>
      <p className="-form-sub-header">Please enter your details</p>
      <button type="button" className="yt-btn tertiary muted block" onClick={toggleSSOModal}>Sign In With SSO</button>
      <div className="separator">or</div>
      <EmailInput
        name="username"
        label="Email"
        value={user.username}
        change={handleFormChange}
        required={true}
      />
      <PasswordInput
        name="password"
        label="Password"
        value={user.password}
        change={handleFormChange}
        required={true}
        password={true}
        helpText={
          <Link className="u-pullRight -forgot" to="/user/forgot-password">
        
            Forgot Password?
            {/* TODO: what happens when an ACRP user hits this? */}
          </Link>
        }
      />
      <button className="yt-btn primary block" type="submit" > Sign In </button>
      {/* TODO: "Don't have an account? Sign up for free!" // need register view first. */}
      {/* TODO: Make a decision on the copy below
      <div>
        <strong><em>PLEASE NOTE:</em></strong>
        <p>You must use Chrome or Firefox in order to have the best experience. Internet Explorer is <strong><em>NOT</em></strong> supported.</p>
        <p>Passwords are case sensitive.</p>
        <p>Email <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a> with any questions.</p>
        <p>By accessing this system I am confirming I am the person assigned this account. By using my unique login credentials I am attesting to my attendance to the assigned training programs</p>
      </div> */}
      <div className="-disclaimer">
        By accessing this system I am confirming I am the person assigned this account. By using my unique login credentials I am attesting to my attendance to the assigned training programs. Please email <a href="mailto:prosupport@simulations-plus.com">prosupport@simulations-plus.com</a> with any questions.
      </div>
    </form>
  )
}

UserLoginForm.propTypes = {
  handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , user: PropTypes.object.isRequired
  , location: PropTypes.object
}

export default withRouter(UserLoginForm);



// WEBPACK FOOTER //
// modules/user/components/UserLoginForm.js.jsx